import React from 'react'
import styled from 'styled-components'
import colours from '../lib/colours'
import IconControl from './icon-control'
import linkify from '../lib/linkify'
import { MobileDeviceWidth } from '../lib/constants'

const StyledDiv = styled.div`
  background: ${colours.mediumBlue};
  padding: 2px 2px;
  @media (max-width: ${MobileDeviceWidth}px) {
    padding-left: 18px;
    padding-right: 18px;
  } 
`
const StyledLink = linkify(styled.div``)

const StyledSpan = styled.span`
  :hover {
    color: ${colours.white} !important;
  }
  color: ${colours.white} !important;
  text-decoration: underline;
`
interface IProps {
  text: string  
}

const MaskControl = (props: IProps) => (
 
  <StyledDiv>
    <StyledLink>
      <StyledSpan>
         {props.text == 'State Map view' &&  <IconControl icon="home" /> }
        {props.text}
      </StyledSpan>
    </StyledLink>
  </StyledDiv>
)

export default MaskControl
